export default {
    methods: {
        isRoutePathActive(location, strict = false) {
            if (strict) {
                return location === this.$route.fullPath;
            } else {
                return RegExp(location).test(this.$route.fullPath);
            }
        },
    },
};
